import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import * as Constants from "../../../data/StringConstants";
import { FoldersApi } from '../../../api/folders/folders';
import FoldersTable from "../../../components/Table/FoldersTable";
import PropTypes from 'prop-types';

/**
 * This container is responsible for data fetching and rendering of corresponding sub-components
 * for the 'All Folders' view which lists all promotions (folders) available to an organization.
 */
export default function AllFoldersContainer(props) {

	const folderState = { data: [], totalItemCount: 0, isLoading: true };
	const [resp, setData] = useState(folderState);
	// How many folders per page
	const shownFolderCount = 100;

	useEffect(() => {
		let isCancelled = false;

		FoldersApi.fetchAllActiveFoldersForAnOrg()
			.then(resp => {
				const newState = {
					data: resp.data,
					totalItemCount: resp.data.length,
					isLoading: false
				};
				!isCancelled && setData(newState);
			})
			.catch(err => console.log(Constants.NO_FOLDERS_RESP_ERR, err));

		return () => (isCancelled = true);
	}, []);
	
	return resp.isLoading ? <LoadingSpinner /> :
		<FoldersTable
			data={resp.data}
			shownFolderCount={shownFolderCount}
			{...props}
		/>
}

AllFoldersContainer.propTypes = {
	userId: PropTypes.number
};
